import ServiceBase from '../ServiceBase';
import userSettingProxy from '../../proxies/common/UserSettingProxy';

class UserSettingService extends ServiceBase {
  getUserSettings(params) {
    return this.getData(() => userSettingProxy.getUserSettings(params));
  }

  updateUserSettings(params) {
    return this.getData(() => userSettingProxy.updateUserSettings(params));
  }

  getUserWatchList(params, source) {
    return this.getData(() =>
      userSettingProxy.getUserWatchList(params, source),
    );
  }

  newWatchList(params) {
    return this.getData(() => userSettingProxy.newWatchList(params));
  }

  renameWatchList(params, source) {
    return this.getData(() => userSettingProxy.renameWatchList(params, source));
  }

  updateWatchList(params, source) {
    return this.getData(() => userSettingProxy.updateWatchList(params, source));
  }

  deleteWatchList(params, source) {
    return this.getData(() => userSettingProxy.deleteWatchList(params, source));
  }

  newWorkspace(params) {
    return this.getData(() => userSettingProxy.newWorkspace(params));
  }

  getWorkspace(params) {
    return this.applyMemoryCache('UserSettingService.getWorkspace', params)(
      () => userSettingProxy.getWorkspace(params),
    );
  }

  updateWorkspace(params) {
    return this.getData(() => userSettingProxy.updateWorkspace(params));
  }

  deleteWorkspace(params) {
    return this.getData(() => userSettingProxy.deleteWorkspace(params));
  }

  getScreeners(params) {
    return this.getData(() => userSettingProxy.getScreeners(params));
  }

  getTopScreeners(params) {
    return this.applyMemoryCache('UserSettingService.getTopScreeners', params)(
      () => userSettingProxy.getTopScreeners(params),
    );
  }

  createScreener(params) {
    return this.getData(() => userSettingProxy.createScreener(params));
  }

  deleteScreener(params) {
    return this.getData(() => userSettingProxy.deleteScreener(params));
  }

  updateScreener(params) {
    return this.getData(() => userSettingProxy.updateScreener(params));
  }

  getChartLayouts(params) {
    return this.applyMemoryCache('UserSettingService.getChartLayouts', params)(
      () => userSettingProxy.getChartLayouts(params),
    );
  }

  createChartLayout(data) {
    return this.applyMemoryCache('UserSettingService.CreateChartLayout', data)(
      () => userSettingProxy.createChartLayout(data),
    );
  }

  updateChartLayout(data) {
    return this.applyMemoryCache('UserSettingService.UpdateChartLayout', data)(
      () => userSettingProxy.updateChartLayout(data),
    );
  }

  deleteChartLayout(data) {
    return this.applyMemoryCache('UserSettingService.DeleteChartLayout', data)(
      () => userSettingProxy.deleteChartLayout(data),
    );
  }

  getChartLayoutShareInfo(data) {
    return this.applyMemoryCache(
      'UserSettingService.GetChartLayoutShareInfo',
      data,
    )(() => userSettingProxy.getChartLayoutShareInfo(data));
  }

  getChangeLogs(data) {
    return this.applyMemoryCache('UserSettingService.GetChangeLogs', data)(() =>
      userSettingProxy.getChangeLogs(data),
    );
  }

  getChangeLogsV3(data) {
    return this.applyMemoryCache('UserSettingService.GetChangeLogs', data)(() =>
      userSettingProxy.getChangeLogsV3(data),
    );
  }

  appendTickerToWatchlist(data) {
    return this.applyMemoryCache(
      'UserSettingService.AppendTickerToWatchlist',
      data,
    )(() => userSettingProxy.appendTickerToWatchlist(data));
  }
}

const userSettingService = new UserSettingService();
export default userSettingService;
